import { render, staticRenderFns } from "./SearchFilterTokens.vue?vue&type=template&id=6ffa44de&scoped=true&"
import script from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens.vue?vue&type=style&index=0&id=6ffa44de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ffa44de",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ffa44de')) {
      api.createRecord('6ffa44de', component.options)
    } else {
      api.reload('6ffa44de', component.options)
    }
    module.hot.accept("./SearchFilterTokens.vue?vue&type=template&id=6ffa44de&scoped=true&", function () {
      api.rerender('6ffa44de', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23m9Z44veXyd5/JS/comp/SearchFilterTokens.vue"
export default component.exports